import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';

function JobSeekerDashboard() {
   const boxStyle = {
    width: '48px',
    height: '48px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: 'bold',
    fontSize: '20px'
  };
  return (

        <div className="content-body">
          <div className="container mt-5">
    <h2 className="mb-4">Job Alerts for Job Seekers</h2>

    <div className="alert alert-success alert-dismissible fade show" role="alert">
      <strong>Software Engineer at TechWorks!</strong><br/>
      Location: Chennai<br/>
      Salary: ₹8-12 LPA<br/>
      <a href="#" className="alert-link">View Job & Apply</a>
      <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
    </div>
    <div className="alert alert-info alert-dismissible fade show" role="alert">
      <strong>UI/UX Designer Opening</strong><br/>
      Location: Madurai<br/>
      Salary: ₹6-10 LPA<br/>
      <a href="#" className="alert-link">View Job & Apply</a>
      <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
    </div>
    <div className="alert alert-warning alert-dismissible fade show" role="alert">
      <strong>Frontend Developer Needed</strong><br/>
      Location: Coimbatore<br/>
      Salary: ₹7-11 LPA<br/>
      <a href="#" className="alert-link">View Job & Apply</a>
      <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
    </div>
    <div className="alert alert-danger alert-dismissible fade show" role="alert">
      <strong>Deadline Approaching: Senior React Developer</strong><br/>
      Location: Trichy<br/>
      Salary: ₹10-15 LPA<br/>
      <a href="#" className="alert-link">View Job & Apply</a>
      <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
    </div>
  </div>
        </div>
      
  );
}

export default JobSeekerDashboard;
